import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCourierScoreHome = async (params: object) => {
  return await GET({
    url: Api.getCourierScoreHome,
    params,
    showError: false
  })
}

export const firstWatch = async (params: object) => {
  return await GET({
    url: Api.firstWatch,
    params,
    showError: false
  })
}
